export const pageTransitionsDialog = {
  "title": "Page Transitions",
  "ok": "OK",
  "cancel": "Cancel",
  "pageTransition": "Page Transition",
  "transition": {
    "title": "Transition",
    "NoTransition": "No Transition",
    "Split": "Split",
    "Blinds": "Blinds",
    "Box": "Box",
    "Wipe": "Wipe",
    "Dissolve": "Dissolve",
    "Glitter": "Glitter",
    "Push": "Push",
    "Cover": "Cover",
    "Uncover": "Uncover",
    "Fade": "Fade",
    "Replace": "Replace",
    "Fly": "Fly"
  },
  "direction": {
    "title": "Direction",
    "Horizontal Inward": "Horizontal Inward",
    "Horizontal Outward": "Horizontal Outward",
    "Vertical Inward": "Vertical Inward",
    "Vertical Outward": "Vertical Outward",
    "Horizontal": "Horizontal",
    "Vertical": "Vertical",
    "Inward": "Inward",
    "Outward": "Outward",
    "Right": "Right",
    "Right Up": "Right Up",
    "Up": "Up",
    "Left Up": "Left Up",
    "Left": "Left",
    "Left Down": "Left Down",
    "Down": "Down",
    "Right Down": "Right Down"
  },
  "speed": {
    "title": "Speed",
    "Slow": "Slow",
    "Medium": "Medium",
    "Fast": "Fast"
  },
  "pageRange": "Page Range",
  "selectedPages": "Selected Pages",
  "allPages": "All Pages",
  "pageForm": "Page Form",
  "to": "To",
  "of": "of"
}
